import React, {useEffect,useState,useContext  } from "react";
import {Helmet} from "react-helmet";
import { useLocation, useNavigate } from 'react-router-dom'
import Lang from '../lang/translations';
import Context from '../context/context';



export default function Tooltip(props) {

    const  context = useContext(Context)
    let navigate = useNavigate();
    
    var location = useLocation();
    location = location.pathname.split("/")

 

	return ( <Helmet>
       
    </Helmet>);
}
